import { Application } from "@core/Application";
import { HTTPClient } from "@core/HTTPClient";
import { DemoUser } from "@models/DemoUser";
import Utils from "@utils/Utils";
import { buildURL, SystemURL } from "./URLCatalog";
import { HTTPClientInterface, HTTPRequest } from "@core/HTTPClientInterface";
import { Logger } from "@utils/Logger";

export class UserServices {
    private httpClient: HTTPClientInterface
    constructor(httpClient: HTTPClientInterface = Application.shared().coreDependencies.unauthenticatedHTTPClient) {
        this.httpClient = httpClient
    }

    async createNewDemoUser(name: string, mobilePhone: string, companyName: string, email: string): Promise<DemoUser> {        
        let user: DemoUser = {
            mobilePhoneNumber: mobilePhone,
            name: name,
            email: email,
            company: companyName,
            currentSessionID: Application.shared().session
        }

        let url = buildURL(SystemURL.Demo.postCreateOrUpdateUser)
        let request = new HTTPRequest()
        request.method = "POST"
        request.url = url
        request.body = user

        let data = await this.httpClient.execute(request)
        return data.result as DemoUser
    }

    async getToken(mobilePhone: string, code: string): Promise<string> {
        let data = {
            mobilePhoneNumber: mobilePhone,
            code: code
        }

        let url = buildURL(SystemURL.Demo.postValidateCode)
        let request = new HTTPRequest()
        request.method = "POST"
        request.url = url
        request.body = data

        let response = await this.httpClient.execute(request)
        return response.result as string
    }
}